import { useMemo } from "react";
import type React from "react";
import { IntlProvider } from "react-intl";

import { detectLocale, messages } from "./locale";

export function OfficeRhythmIntlProvider({ children }: { children: React.ReactNode }) {
  const locale = useMemo(() => detectLocale(), []);

  return (
    <IntlProvider
      locale={locale}
      defaultLocale="en"
      messages={messages[locale]}
      onError={(err) => {
        if (err.code === "MISSING_TRANSLATION") return;
        console.warn(err.message);
      }}
    >
      {children}
    </IntlProvider>
  );
}
